module.exports = __webpack_public_path__ + "img/icon_circle-blue.1938fad1.svg";